import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { APP_ROUTES } from '../constants/app-routes';


@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private currentTitle: string = APP_ROUTES.fallback.title;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setTitleFromRoute();
      });
  }

  private setTitleFromRoute() {
    const url = this.router.url;
    const baseRoute = url.split('/')[1] || ''; // Get the first segment or empty string for root

    // Find the matching route in APP_ROUTES
    const routeKey = Object.keys(APP_ROUTES).find(
      key => APP_ROUTES[key as keyof typeof APP_ROUTES].base === baseRoute
    );
    this.currentTitle = routeKey
      ? APP_ROUTES[routeKey as keyof typeof APP_ROUTES].title
      : APP_ROUTES.fallback.title;
  }

  getTitle(): string {
    return this.currentTitle;
  }
}